import React, { useState, useEffect } from "react";
import "./productform.css";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

const ProductEditForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [preview, setPreview] = useState(
    "https://cdn-icons-png.flaticon.com/512/10446/10446694.png"
  );
  const [categories, setCategories] = useState([]);
  const [file, setFile] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    category_id: "",
    description: "",
    features: "",
  });

  useEffect(() => {
    if (id) {
      fetchCategories();
      fetchProductById();
    } else {
      toast.error("No product ID provided for edit.");
      navigate("/products");
    }
  }, [id]);

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch("https://viklang.serverscripts.in/api/v1/category/view", {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await response.json();
      if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
        navigate('/login');
        return;
      }
      if (result.success) setCategories(result.data);
      else toast.error(result.message);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch categories");
    }
  };

  const fetchProductById = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `https://viklang.serverscripts.in/api/v1/product/viewproductbyid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id }),
        }
      );
        if (response.status === 401) {
          toast.error("Session expired, please log in again");
          localStorage.removeItem("authToken");
          navigate('/login');
          return;
        }
      const result = await response.json();
      if (result.success && result.data) {
        setFormData({
          name: result.data.name || "",
          category_id: result.data.category_id || "",
          description: result.data.description || "",
          features: result.data.features || "",
        });
        if (result.data.img) setPreview(result.data.img);
      } else {
        toast.error(result.message || "Product not found");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch product details");
    }
  };

  const loadFile = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setPreview(URL.createObjectURL(selectedFile));
      setFile(selectedFile);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("id", id);
    data.append("name", formData.name);
    data.append("category_id", formData.category_id);
    data.append("features", formData.features);
    data.append("description", formData.description);
    if (file) data.append("image", file);

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch("https://viklang.serverscripts.in/api/v1/product/edit", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: data,
      });

      const result = await response.json();
      if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
       navigate('/login');
        return;
      }
      if (result.success) {
        toast.success("Product updated successfully!");
        navigate(`/product-details`);
      } else {
        toast.error(result.message || "Failed to update product");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating product");
    }
  };

  return (
    <div className="product-form">
      <h2>Edit Product</h2>
      <form className="form-section" onSubmit={handleUpdate}>
        <div className="card left-section">
          <div className="image-section">
            <label htmlFor="fileSelect">
              <img src={preview} alt="Preview" className="image-preview" />
            </label>
            <input
              type="file"
              id="fileSelect"
              className="hidden"
              accept="image/*"
              onChange={loadFile}
            />
          </div>

          <div className="input-section">
            <div className="form-group">
              <label className="form-label">Product Title</label>
              <input
                type="text"
                name="name"
                className="form-input"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Select Category</label>
              <select
                name="category_id"
                className="form-input"
                value={formData.category_id}
                onChange={handleChange}
                required
              >
                <option value="">-- Select Category --</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.category_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Features</label>
              <input
                type="text"
                name="features"
                value={formData.features}
                onChange={(e) =>
                  setFormData({ ...formData, features: e.target.value })
                }
                placeholder="Please enter the key points, separated by commas."
                className="form-input shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Description</label>
              <textarea
                name="description"
                className="form-input textarea"
                value={formData.description}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <div className="button-row">
              <button type="submit" className="product-save-button">
                Update
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductEditForm;
